
import ToggleOffCircle from "../../../assets/outline/ToggleOffCircle.svg";

import { IconProps } from "../../../types";

const cx = require('classnames');

export default function ToggleOffCircleIcon({ className, dataTestid = "ToggleOffCircleIcon", ...rest }: IconProps) {
  const classes = cx(className);

  return (
    <ToggleOffCircle data-testid={dataTestid} className={classes} {...rest} />
  );
}
